module.exports = __webpack_public_path__ + "assets/images/mobile-app-preview/logo-placeholder.1b6cf921ca410e8151a6db28a91cc986.webp";